import React,{ Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import routes from '../routes';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
//import DestinationsSelect from '../views/Pages/PortalPage/DestinationsSelect/DestinationsSelect';

class PortalLayout extends Component {

    constructor(props) {
        super(props);
        const initialCountryId = parseInt(sessionStorage.getItem('selectedCountryId') || '0', 10);
        const currentPath = window.location.pathname;
        const isHomePage = currentPath === '/home' || currentPath === '/';
        this.state = {
            searchQuery: "",
            submittedSearchQuery: "",
            products: [],
            isLoadingProducts: false,
            countryId: initialCountryId,

            // showCountrySelectionModal: true, 
        };
    }


    handleCountryFilterChange = (countryId, countryName) => {
        this.setState({
            countryId: countryId,
        });
    }

    handleCountrySubmit = (countryId, countryName) => {
        this.setState({
            countryId: countryId,
            isCountrySelected: true,
        });
    }

    handleSearchSubmit = (query) => {
        this.setState({
            submittedSearchQuery: query,
            searchQuery: ""
        });
    }

    handleSearch = (query) => {
        this.setState({ searchQuery: query, showSearchDropdown: query.length > 0 });
    }

    handleProductsLoaded = (products) => {
        this.setState({ products: products, isLoadingProducts: false });
    }

    handleProductsLoading = (isLoading) => {
        this.setState({ isLoadingProducts: isLoading });
    }

    render() {
        let filteredRoute = [];
        routes.forEach(route => {
            if (route.path === '/home' || route.path === '/home/productDetail/:id' ||
                route.path === '/home/viewCart' || route.path === '/home/confirmPage' || route.path === '/home/purchaseSuccess' ||
                route.path === '/home/purchaseSuccess' || 
                route.path === '/home/list' || 
                 route.path === '/home/joytel-detail/:orderTid' || 
                route.path === '/home/roam-detail/:orderNum' ||
                 route.path === '/home/data-enquiry' ||
                route.path === '/home/renew-detail/:orderNum' ||
                route.path === '/404' || route.path === '/500' || 
                route.path === '/home/contact' || 
                route.path === '/home/faq' || 
                route.path === '/home/list' ||
                route.path === '/user/changepassword' || route.path === '/user/myprofile') {
                filteredRoute.push(route);
            }
        });

         const searchProps = {
            searchQuery: this.state.submittedSearchQuery,
            onSearchSubmit: this.handleSearchSubmit,
            onSearch: this.handleSearch,
            onProductsLoaded: this.handleProductsLoaded,
            onProductsLoading: this.handleProductsLoading,
            initialCountryId: this.state.countryId,
            onCountrySelect: this.handleCountryFilterChange, 
        };

        return(
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh'
            }}>
                <Navbar 
                    onSearch={this.handleSearch} 
                    onSearchSubmit={this.handleSearchSubmit}
                    searchQuery={this.state.searchQuery} 
                    products={this.state.products}
                    isLoadingProducts={this.state.isLoadingProducts} />
                <div style={{ flex: '1 0 auto' , backgroundColor: '#f8f9fa'}}>
                        <Switch>
                    {filteredRoute.map((route, idx) => {
                        return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => {
                                    const mergedProps = {
                                        ...props,
                                        ...searchProps
                                    };
                                    return <route.component {...mergedProps} />;
                                }} />)
                        : (null)},
                    )}
                    <Redirect to={{ pathname: "/home" }} />
                </Switch>
                </div>
                <Footer />
             </div>
    )}
}

export default PortalLayout;
